import React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function OrdinaSubitoSuWhatsapp() {
  return <section id="ordina-subito-su-whatsapp" className="dark bg-background text-foreground relative w-full">
      {}
      <div className="absolute inset-0 bg-[#F9EDD6] z-0" />
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566661/img/sicilian_sweets_whatsapp_cta_bg.png)] bg-cover bg-center opacity-10 z-0" />

      {}
      <div className="relative z-10 w-full h-px bg-gradient-to-r from-transparent via-[hsl(41,48%,56%)] to-transparent opacity-80" />

      <div className="relative z-10 container mx-auto px-4 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          
          {}
          <div className="flex-1 text-center md:text-left space-y-4">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3B32] tracking-tight">
              Hai un desiderio improvviso?
            </h2>
            <p className="text-lg text-[#5D4037] max-w-xl mx-auto md:mx-0 leading-relaxed font-sans">Voglia di un cannolo fresco o di una torta speciale? Scrivici su WhatsApp e prenota i tuoi dolci preferiti.</p>
          </div>

          {}
          <div className="flex-shrink-0">
            <Button asChild size="lg" className="bg-[hsl(41,48%,56%)] hover:bg-[hsl(41,48%,50%)] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg shadow-[hsl(41,48%,56%)]/30 animate-pulse transition-transform hover:scale-105">
              <Link to="https://wa.me/393402498369" newTab>
                <MessageCircle className="mr-2 h-6 w-6 fill-current" aria-hidden="true" />
                Scrivici su WhatsApp
              </Link>
            </Button>
          </div>
          
        </div>
      </div>

      {}
      <div className="relative z-10 w-full h-px bg-gradient-to-r from-transparent via-[hsl(41,48%,56%)] to-transparent opacity-80" />
    </section>;
}